import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiSend, FiMail, FiPhone } from 'react-icons/fi';

const Contact = () => {
  return (
    <section id="contact" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-brand-black rounded-[3rem] overflow-hidden shadow-3d grid lg:grid-cols-2">
          <div className="p-16 lg:p-24 text-white">
            <h2 className="text-5xl lg:text-6xl font-black mb-8">Let's Start a <br /><span className="text-brand-purple">Conversation.</span></h2>
            <p className="text-xl text-gray-400 mb-12 font-medium leading-relaxed">
              Whether you’re exploring coaching for yourself or development for your team, I’d love to connect. No pressure. No hard sell. Just a real conversation.
            </p>
            
            <div className="space-y-8">
              <div className="flex items-center space-x-6">
                <div className="w-14 h-14 bg-brand-purple rounded-2xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiMail} className="text-white w-6 h-6" />
                </div>
                <span className="text-xl font-bold">beckyrentzel@rgleadership.com</span>
              </div>
              <div className="flex items-center space-x-6">
                <div className="w-14 h-14 bg-zinc-800 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiPhone} className="text-white w-6 h-6" />
                </div>
                <span className="text-xl font-bold">+1 (614) 530-7788</span>
              </div>
            </div>
          </div>
          
          <div className="bg-white/5 backdrop-blur-xl p-16 lg:p-24 border-l border-white/10">
            <form className="space-y-6">
              <div>
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Full Name</label>
                <input type="text" className="w-full bg-white/10 border border-white/20 rounded-xl px-6 py-4 text-white placeholder:text-gray-600 focus:outline-none focus:border-brand-purple focus:bg-white/20 transition-all" />
              </div>
              <div>
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Email Address</label>
                <input type="email" className="w-full bg-white/10 border border-white/20 rounded-xl px-6 py-4 text-white placeholder:text-gray-600 focus:outline-none focus:border-brand-purple focus:bg-white/20 transition-all" />
              </div>
              <div>
                <label className="block text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">How can we help?</label>
                <textarea rows="4" placeholder="Tell me a little about your current role and challenges..." className="w-full bg-white/10 border border-white/20 rounded-xl px-6 py-4 text-white placeholder:text-gray-600 focus:outline-none focus:border-brand-purple focus:bg-white/20 resize-none transition-all"></textarea>
              </div>
              <button className="w-full bg-brand-purple text-white py-5 rounded-xl font-black text-lg hover:bg-purple-700 transition-all shadow-xl flex items-center justify-center space-x-3">
                <span>SEND MESSAGE</span>
                <SafeIcon icon={FiSend} className="w-5 h-5" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;